// i18n
import "./locales/i18n";
// scroll bar
import "simplebar/src/simplebar.css";
// editor
import "react-quill/dist/quill.snow.css";
// polaris
import "@shopify/polaris/build/esm/styles.css";

import ReactDOM from "react-dom/client";

import App from "./App";
import { onCLS, onINP, onLCP } from "web-vitals";

onCLS(console.log, { reportAllChanges: true });
onINP(console.log);
onLCP(console.log, { reportAllChanges: true });

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
